import { render, staticRenderFns } from "./ListPayments.vue?vue&type=template&id=1959ad07"
import script from "./ListPayments.vue?vue&type=script&lang=js"
export * from "./ListPayments.vue?vue&type=script&lang=js"
import style0 from "./ListPayments.vue?vue&type=style&index=0&id=1959ad07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports